module.exports = __webpack_public_path__ + "img/product_17.58e4219.webp";